import { useAppSelector } from "@hypexone/uicore";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import LanguageSelector from "./LanguageSelector";

interface ChangeLanguageModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ChangeLanguageModal: React.FC<ChangeLanguageModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { langData } = useAppSelector((state) => state.cms);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm overflow-hidden rounded-md bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between bg-[#ececec] px-4 py-2.5">
          <h2 className="text-[14px] font-bold text-black">
            {langData?.["change_language"] ?? "Change Language"}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="text-[20px] leading-none text-[#666] hover:text-black"
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="px-4 py-4">
          <LanguageSelector
            key={isOpen ? "open" : "closed"}
            showActionButtons
            onApply={onClose}
            onCancel={onClose}
          />
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ChangeLanguageModal;
